import 'parsleyjs';

$.extend(Parsley.options, {
    errorClass: 'is-invalid',
    successClass: 'is-valid',
    errorsWrapper: '<span class="invalid-feedback"></span>',
    errorTemplate: '<div></div>',
    trigger: 'change',
});

Parsley
    .addValidator('phone', {
        requirementType: 'string',
        validateString(value) {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(value);
        },
        messages: {
            en: 'This value should be a valid phone number.',
        },
    });

export default Parsley;
